module.exports = __webpack_public_path__ + "img/grid-data-loading.png";